/* eslint-disable */

export default {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "picture-quiz",
    items: [
      { id: "q1", question: "Cén dath atá ar an spéir?", answers: ["gorm"], image: "https://images.unsplash.com/photo-1531147646552-1eec68116469?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1950%26q%3D80" },
      { id: "q2", question: "Cén dath atá ar an liathróid cispheile?", answers: ["oráiste", "donn"], image: "https://images.unsplash.com/photo-1519861531473-9200262188bf?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1951%26q%3D80" },
      { id: "q3", question: "Cén dath atá ar an banana?", answers: ["buí"], image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1400%26q%3D80" },
      { id: "q4", question: "Cén dath atá ar an rós?", answers: ["dearg"], image: "https://images.unsplash.com/photo-1496857239036-1fb137683000?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1950%26q%3D80" },
      { id: "q5", question: "Cén dath atá ar an úll?", answers: ["glas"], image: "https://images.unsplash.com/photo-1523757478383-0dff16823e84?ixlib%3Drb-1.2.1%26ixid%3DeyJhcHBfaWQiOjEyMDd9%26auto%3Dformat%26fit%3Dcrop%26w%3D1950%26q%3D80" },
    ],
  },

  botId: "nualang.picture-quiz.0.0.2",
  botName: "picture_quiz",
  description: "picture_quiz_desc",
  difficulty: "ALL",
  learnLang: "irish",
  name: "Joey",
  botAvatar:
    "https://d3g1pegw1dz0u6.cloudfront.net/eyJidWNrZXQiOiJsZXRzdGFsay1pbWFnZXMtZGV2Iiwia2V5IjoiYXZhdGFycy8wMTAtZ2lybC0xLnBuZyJ9",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-images?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Fáilte go dtí an tráth na gceist dathanna
Óstáil ag Joey.

Cé chomh maith agus atá dathanna ar eolas agat?

Abair "Dia duit" le Joey chun tosú.`,
  voice: "Joey",
  versionQuestion: "How many questions would you like in this template?",
};
